import { PermissionAction, PermissionSubject } from './enums';

export const findPermissionWithAction = (
  permissionsSubject: PermissionSubject[],
  action: PermissionAction,
  permission: Partial<Record<PermissionSubject, Record<PermissionAction, boolean>>> | undefined
): PermissionSubject => {
  const foundPermission = permissionsSubject.find((permissionSub) => {
    const permissionConfig = permission?.[permissionSub];

    return permissionConfig && permissionConfig[action] === true;
  });

  return foundPermission || permissionsSubject[0];
};
